export default class AvatarRepository {
  constructor(avatarAPIService) {
    if (new.target === AvatarRepository)
      throw new Error("Cannot instantiate an abstract class.");

    this.avatarAPIService = avatarAPIService;
  }

  async getAvatarDetailsByKey(key) {
    throw new Error("Method 'getAvatarDetailByKey(key)' must be implemented.");
  }

  async getAvatarDetailsById(id) {
    throw new Error("Method 'getAvatarDetailById(id)' must be implemented.");
  }
}
